import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import { ButtonPrimary, ErrorFeedbackScreen, SuccessFeedbackScreen, skinVars } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import PersonalData from '../..';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

export interface FeedbackAddDataInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    typeVerificationDesktop?: any;
    errDesktop?: any;
    stateFeedbackDesktop?: any;
}

export const FeedbackAddData: React.FC<FeedbackAddDataInterface> = ({
    fromDesktop,
    setComponentSelected,
    typeVerificationDesktop,
    errDesktop,
    stateFeedbackDesktop,
}: FeedbackAddDataInterface) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const storage = localStorage.getItem('storage') || '';
    let type: any;
    let state: any;
    let err: any;
    if (storage) {
        const storageJson = JSON.parse(storage);
        type = storageJson.type;
        state = storageJson.state;
        err = storageJson.err;
    }

    const stateFeedback = fromDesktop ? stateFeedbackDesktop : state;
    const typeFeedback = fromDesktop ? typeVerificationDesktop : type;
    const error = fromDesktop ? errDesktop : err;

    const sendToNative = (url: string, title?: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        if (navigateParams(type, url, queryParams)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackAddData-page'
            style={{
                background: stateFeedback === 'SUCCESS' ? skinVars.colors.backgroundBrand : skinVars.colors.background,
            }}
        >
            {stateFeedback === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={
                        typeFeedback === 'mobile'
                            ? t('profileAddMobileFeedbackSuccessTitle')
                            : t('profileAddEmailFeedbackSuccessTitle')
                    }
                    description={
                        typeFeedback === 'mobile'
                            ? t('profileAddMobileFeedbackSuccessSubtitle')
                            : t('profileAddEmailFeedbackSuccessSubtitle')
                    }
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={error?.title}
                    description={error?.localizedDescription}
                    errorReference={'Código de error: ' + `${error?.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/profile');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default FeedbackAddData;
